'use client';

import { Chip, Theme } from '@mui/material';

type CategoryChipProps = {
  label: string;
  isActive: boolean;
  onClick: () => void;
  tag_slug?: string;
};

export function CategoryChip({ label, isActive, onClick, tag_slug }: CategoryChipProps) {
  return (
    <Chip
      label={label}
      onClick={onClick}
      data-tag-slug={tag_slug}
      sx={{
        // Design spec (Landing.dc.html chip row): 13.5px / 500, 7×15 padding,
        // fully-rounded (999px) pill. Active = primary fill with contrastText;
        // inactive = transparent with a muted label + subtle border that brightens
        // on hover.
        fontWeight: 500,
        fontSize: '13.5px',
        cursor: 'pointer',
        transition: 'border-color 140ms ease, background-color 140ms ease, color 140ms ease',
        bgcolor: isActive ? 'primary.main' : 'transparent',
        color: isActive ? 'primary.contrastText' : 'text.secondary',
        border: '1px solid',
        borderColor: isActive ? 'primary.main' : 'divider',
        borderRadius: '999px',
        height: 32,
        '& .MuiChip-label': {
          px: '15px',
          py: 0,
        },
        '&:hover': {
          bgcolor: isActive ? 'primary.main' : 'transparent',
          color: isActive ? 'primary.contrastText' : 'text.primary',
          borderColor: isActive
            ? 'primary.main'
            : (theme: Theme) =>
                theme.palette.mode === 'dark' ? '#3a352e' : theme.palette.text.disabled,
        },
      }}
    />
  );
}

export default CategoryChip;
